<template slot="header">

  <div class="gebrauchtwagenbar">
    <div class="gebrauchtwagenbar-borders">
      <div class="largetext center bold narrow_05">{{ title }}<span v-if="hasAsterisk">&nbsp;*</span></div>

      <div class="gebrauchtwagenbar-container">
        <div class="gebrauchtwagenbar-left"
             v-if="pro > 0"
             v-bind:style="{ width: getProWidth + '%' }"
             v-bind:class="{ 'bc-green-gradient' : isGreen(), 'bc-yellow-gradient': isYellow(), 'bc-red-gradient': isRed() }">
          <div v-if="pro > 79" class="smalltext gebrauchtwagenbar-righttext"> <span>{{ pro }}%</span></div>
        </div>
        <div class="gebrauchtwagenbar-middle" v-if="shouldFillGap && pro < 100">
          <div v-if="pro < 80" class="smalltext gebrauchtwagenbar-lefttext"> <span>{{ pro }}%</span></div>
        </div>
      </div>

      <div>
        <div class="smalltext narrow_05 gebrauchtwagenbar-lefttext">
          0<span v-if="isPercentage">%&nbsp;</span>{{ proHeader }}
        </div>
        <div class="smalltext narrow_05 gebrauchtwagenbar-righttext">
          100<span v-if="isPercentage">%&nbsp;</span>{{ proHeader }}
        </div>
      </div>

      <div>&nbsp;</div>
    </div>
    <!-- <div class="gebrauchtwagenbar-gray gebrauchtwagenbar-line"></div> -->
    <div class="smalltext center">
      <span>{{$t('Webportal.Points')}}:</span>
      <span>{{ points }}</span><span> {{$t('Webportal.RangeOf')}} </span><span>{{ pointsMax }}</span>
    </div>
  </div>

</template>


<script>

  export default {
    name: 'GebrauchtwagenItem',

    props:{
      'hasAsterisk': Boolean,
      'isPercentage': Boolean,
      'shouldFillGap': Boolean,
      'title': String,
      'proHeader': String,
      'contraHeader': String,
      'pro': Number,
      'contra': Number,
      'points': Number,
      'pointsMax': Number,
      'tooltip': String
    },

    methods: {
      getTooltip() {
        return this.tooltip;
      },
      isGreen (){
        return this.pro > 89;
      },
      isYellow (){
        return this.pro > 79 && this.pro < 90;
      },
      isRed (){
        return this.pro < 80;
      }
    },

    computed: {
      getProWidth: function() {
        return this.pro;
      },
      getContraWidth: function() {
        if (this.contra < 1) return 0;
        if (this.isPercentage)  return this.contra - 1;
        return (100 * this.contra) / (this.pro + this.contra) - 1
      },
    }
  }

</script>

<style scoped>

</style>
